import ValidationRules from './ValidationRules'

export default ValidationRules



// WEBPACK FOOTER //
// ./src/legacy/components/ValidationRules/index.js